import { jsx as d } from "react/jsx-runtime";
import { c as _ } from "../clsx-OuTLNxxd.js";
import { useState as f, useEffect as m } from "react";
import { c as y } from "../background-CRdXfOz5.js";
const B = "DrawerBody-module_body__8H5gs",
  w = "DrawerBody-module_default-size__guTU7",
  D = "DrawerBody-module_show__ru8t6",
  g = "DrawerBody-module_hide__4Bl9M",
  h = "DrawerBody-module_content-wrapper__t1G8V",
  S = "DrawerBody-module_padding-top__LTphi",
  T = "DrawerBody-module_default-container__pSsTD",
  e = {
    body: B,
    defaultSize: w,
    show: D,
    hide: g,
    contentWrapper: h,
    paddingTop: S,
    defaultContainer: T
  },
  W = e.defaultContainer,
  k = _ref => {
    let {
      paddingTop: n = !0,
      show: o,
      className: a,
      dataContentName: s,
      size: i,
      backgroundColor: l = "white",
      children: c
    } = _ref;
    const [t, r] = f(o),
      u = y(l);
    m(() => {
      o && r(!0);
    }, [o]);
    const p = () => {
      o || r(!1);
    };
    return !t && !o ? null : /* @__PURE__ */d("div", {
      "data-content-name": s,
      onTransitionEnd: p,
      className: _(e.body, u, {
        [e.paddingTop]: n,
        [e.show]: t,
        [e.hide]: !o,
        [e.defaultSize]: i == "default"
      }, a),
      children: /* @__PURE__ */d("div", {
        className: e.contentWrapper,
        children: c(t)
      })
    });
  };
export { k as DrawerBody, W as defaultDrawerBodyContainerStyle };